import React from "react";
import classnames from "classnames";
import { usePagination, DOTS } from "../hooks/usePagination";

const Pagination = (props) => {
  const {
    onPageChange,
    totalCount,
    siblingCount = 1,
    currentPage,
    pageSize,
    className,
  } = props;

  const paginationRange = usePagination({
    currentPage,
    totalCount,
    siblingCount,
    pageSize,
  });

  // If there are less than 2 times in pagination range we shall not render the component
  if (currentPage === 0 || paginationRange.length < 2) {
    return null;
  }

  const onNext = () => {
    onPageChange(currentPage + 1);
  };

  const onPrevious = () => {
    onPageChange(currentPage - 1);
  };

  let lastPage = paginationRange[paginationRange.length - 1];

  return (
    <ul
      className={classnames(
        "pagination-container shadow-default rounded-full",
        {
          [className]: className,
        }
      )}
    >
      {/* Left navigation arrow */}
      <li
        className={classnames("pagination-item", {
          disabled: currentPage === 1,
        })}
        onClick={onPrevious}
      >
        {/* <div className="arrow left" /> */}
        <span className="left">
          <img src="/assets/left-arrow-pag.svg" alt="" />
        </span>
      </li>
      <li className="flex">
        {paginationRange.map((pageNumber, index) => {
          // If the pageItem is a DOT, render the DOTS unicode character
          if (pageNumber === DOTS) {
            return (
              <p className="pagination-item dots" key={index}>
                &#8230;
              </p>
            );
          }

          // Render our Page Pills
          return (
            <p
              key={index}
              className={classnames("pagination-item", {
                selected: pageNumber === currentPage,
              })}
              onClick={() => onPageChange(pageNumber)}
            >
              {pageNumber}
            </p>
          );
        })}
        {/*  Right Navigation arrow */}
      </li>
      <li
        className={classnames("pagination-item", {
          disabled: currentPage === lastPage,
        })}
        onClick={onNext}
      >
        {/* <div className="arrow right" /> */}
        <span className="right">
          <img src="/assets/right-arrow-pag.svg" alt="" />
        </span>
      </li>
    </ul>
  );
};

export default Pagination;
